<template>
  <v-row no-gutters>
    <v-text-field
      v-model="model"
      class="flex-grow-1 pt-0 text-body-2"
      :placeholder="label"
      :disabled="disabled"
      single-line
      hide-details="auto"
    />
  </v-row>
</template>

<script>
export default {
  name: 'ExtractionFieldText',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
